module.exports = __webpack_public_path__ + "img/dca8b67.jpg";